<template>
    <div class="suggestions" v-if="suggestions && suggestions.length">
        <div v-for="(e, i) in suggestions" :key="i" class="suggestions__item" @click="setSuggestion(e)">
            <p v-if="e.name" class="single-long-string-nowrap">
                <span v-if="e.name.length > 30" :title="e.name">{{ e.name }}</span>
                <span v-else>{{ e.name }}</span>
            </p>
            <p v-if="e.inn">
                <b>ИНН: </b>
                <span>{{ e.inn }}</span>
            </p>
            <p v-if="e.address">
                {{ e.address }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: ['suggestions', 'setSuggestion']
}
</script>

<style lang="sass" scoped>
@use 'styles/global-variables.sass'

$border: 1px solid lightgray

.single-long-string-nowrap
    white-space: nowrap
    text-overflow: ellipsis
    overflow: hidden

.suggestions
    position: absolute
    background-color: #fff
    width: 340px
    border-right: $border
    border-left: $border
    z-index: 2
    font-size: 14px
    &__item
        cursor: pointer
        border-bottom: $border
        padding-left: 10px
        padding-top: 5px
        padding-bottom: 5px
        padding-right: 10px
        p
            margin: 0
            padding: 0
</style>